// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"95ed933b","863":"95ed933b"}[chunkId] + ".chunk.css";
};